import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full relative z-[9999]"
}
const _hoisted_2 = { class: "top-0 sticky header-container lg:border-b border-solid border-light-grey bg-racq-true-white" }
const _hoisted_3 = { class: "forms-header w-full" }
const _hoisted_4 = { class: "header-logo" }
const _hoisted_5 = { class: "form-title" }
const _hoisted_6 = { class: "hidden ml-auto mr-[18px] lg:block xl:hidden w-[300px]" }
const _hoisted_7 = { class: "help-content" }

import { computed, onMounted } from 'vue';
import {
  Text as ScText,
  Image as ScImage,
  Link as ScLink,
  ComponentFields,
  ComponentRendering,
  Field,
} from '@sitecore-jss/sitecore-jss-vue';
import FormStepperBar from '@/components/FormStepperBar/FormStepperBar.vue';
import { useFormStore } from '@/store';
import GlobalAlert from '@/components/GlobalAlert/GlobalAlert.vue';
import { GlobalAlertsVisibility } from '@/enums/global-alerts.enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    fields: {},
    rendering: {},
    pageTitle: { default: '' },
    globalAlerts: {}
  },
  setup(__props: any) {

const formStore = useFormStore();

const props = __props;

const displayGlobalAlerts = props.globalAlerts?.filter(
  (x: any) =>
    x.fields?.visibility?.value === GlobalAlertsVisibility.All ||
    x.fields?.visibility?.value === GlobalAlertsVisibility.Quotes
);

const pageTitle = computed(() => {
  const pageTitle = props.fields?.pageTitle as Field<any>;
  return pageTitle?.value ? pageTitle : { value: props.pageTitle };
});

onMounted(() => {
  const pageTitleField = pageTitle.value;
  formStore.setPageTitle(pageTitleField.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_unref(displayGlobalAlerts)?.length ?? 0) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayGlobalAlerts), (item, itemIndex) => {
            return (_openBlock(), _createBlock(GlobalAlert, {
              key: itemIndex,
              type: item?.fields?.type?.value,
              content: item?.fields?.content?.value,
              visibility: item?.fields?.visibility?.value
            }, null, 8, ["type", "content", "visibility"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ScLink), {
            class: "flex",
            field: _ctx.fields.logoLink ? _ctx.fields.logoLink : {}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ScImage), {
                media: _ctx.fields.racqLogo
              }, null, 8, ["media"])
            ]),
            _: 1
          }, 8, ["field"])
        ]),
        _createElementVNode("h1", _hoisted_5, [
          _createVNode(_unref(ScText), { field: pageTitle.value }, null, 8, ["field"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(formStore).showStepper)
            ? (_openBlock(), _createBlock(FormStepperBar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(ScLink), {
            field: _ctx.fields.helpContentLink ? _ctx.fields.helpContentLink : {}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ScImage), {
                media: _ctx.fields.helpLogo
              }, null, 8, ["media"])
            ]),
            _: 1
          }, 8, ["field"])
        ])
      ])
    ])
  ], 64))
}
}

})